import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

// Sharp-edged pill button. variant: solid | outline | accent
export const CTAButton = ({ to, href, onClick, children, variant = "solid", className = "", type, testid, ...rest }) => {
  const base =
    "group inline-flex items-center gap-2 px-7 py-3.5 text-sm font-medium tracking-wide transition-all duration-300 rounded-none";
  const variants = {
    solid: "bg-primary text-primary-foreground hover:bg-accent hover:text-accent-foreground",
    outline: "border border-foreground text-foreground hover:bg-foreground hover:text-background",
    accent: "bg-accent text-accent-foreground hover:opacity-90",
    ghost: "text-foreground hover:text-accent",
  };
  const cls = `${base} ${variants[variant]} ${className}`;
  const inner = (
    <>
      <span>{children}</span>
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </>
  );
  if (to) return <Link to={to} data-testid={testid} className={cls} {...rest}>{inner}</Link>;
  if (href) return <a href={href} data-testid={testid} className={cls} {...rest}>{inner}</a>;
  return <button type={type || "button"} data-testid={testid} onClick={onClick} className={cls} {...rest}>{inner}</button>;
};
